import {inject, Injectable, signal} from '@angular/core';
import {MypartHttpService} from './mypart-http.service';

const SIGNED_UP_KEY = 'v2s_lead_signed_up';
const DISMISSED_KEY = 'v2s_lead_dismissed_at';
const EMAILS_KEY = 'v2s_collected_emails';
const COOLDOWN_MS = 30 * 60 * 1000; // 30 minutes
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const FORM_TYPE = 'V2S_CONTACT';

@Injectable({
  providedIn: 'root'
})
export class LeadGenService {
  private http = inject(MypartHttpService);
  private _signedUp = signal(localStorage.getItem(SIGNED_UP_KEY) === 'true');
  readonly signedUp = this._signedUp.asReadonly();

  isValidEmail(email: string): boolean {
    return EMAIL_REGEX.test(email.trim());
  }

  isDismissCooldownActive(): boolean {
    const dismissedAt = localStorage.getItem(DISMISSED_KEY);
    if (!dismissedAt) {
      return false;
    }
    return Date.now() - parseInt(dismissedAt, 10) < COOLDOWN_MS;
  }

  shouldShowPopup(): boolean {
    return !this._signedUp() && !this.isDismissCooldownActive();
  }

  submitEmail(email: string): void {
    const trimmed = email.trim();
    const existing = this.getCollectedEmails();
    if (!existing.some(e => e.email === trimmed)) {
      existing.push({email: trimmed, timestamp: Date.now()});
      localStorage.setItem(EMAILS_KEY, JSON.stringify(existing));
    }
    localStorage.setItem(SIGNED_UP_KEY, 'true');
    this._signedUp.set(true);

    // Fire-and-forget submission to the backend; errors are logged in the service.
    // The local record + signed-up flag above are the source of truth for the UI.
    this.http.sendForm(trimmed, FORM_TYPE).subscribe({
      error: () => { /* already logged in MypartHttpService */ }
    });
  }

  recordDismissal(): void {
    localStorage.setItem(DISMISSED_KEY, Date.now().toString());
  }

  getCollectedEmails(): {email: string; timestamp: number}[] {
    const raw = localStorage.getItem(EMAILS_KEY);
    if (!raw) {
      return [];
    }
    try {
      return JSON.parse(raw);
    } catch {
      return [];
    }
  }
}
